import script from "./ShareReadingSheet.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareReadingSheet.vue?vue&type=script&setup=true&lang=js"

import "./ShareReadingSheet.vue?vue&type=style&index=0&id=39c160a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39c160a0"]])

export default __exports__